import styled from 'styled-components';

export const LicensesTablePriceMainStyled = styled.p`
	margin-bottom: 0;
	font-size: 14px;
`;

export const LicensesTablePriceInfoStyled = styled.p`
	color: rgb(140, 140, 140);
`;

export const PriceContainerStyled = styled.div`
	gap: 4px;
	display: flex;
	align-items: center;
`;
